import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatPhoneNumber = (value) => {
  if (!value) return '';

  const raw = String(value).replace(/^\s+/, '');

  // 국가번호(+)로 시작하면 국제번호로 본다.
  // 나라마다 자릿수와 끊는 위치가 달라 자동으로 하이픈을 넣지 않고 입력한 모양을 그대로 살린다.
  // 예: +82-10-1234-5678, +00-000-000, +1 (415) 555-0100
  if (raw.startsWith('+')) {
    return '+' + raw.slice(1).replace(/[^0-9\-\s()]/g, '');
  }

  const number = raw.replace(/[^0-9]/g, '');

  if (number.length < 3) return number;
  if (number.startsWith('02')) {
    if (number.length <= 5) return number.replace(/(\d{2})(\d{1,3})/, '$1-$2');
    if (number.length <= 9) return number.replace(/(\d{2})(\d{3})(\d{1,4})/, '$1-$2-$3');
    return number.replace(/(\d{2})(\d{4})(\d{1,4})/, '$1-$2-$3');
  }

  if (number.length <= 7) return number.replace(/(\d{3})(\d{1,3})/, '$1-$2');
  if (number.length <= 10) return number.replace(/(\d{3})(\d{3})(\d{1,4})/, '$1-$2-$3');
  return number.replace(/(\d{3})(\d{4})(\d{1,4})/, '$1-$2-$3');
};
